__turbopack_context__.v({
  "sign_in_menu": "SignInMenu-module-scss-module__I3YlJa__sign_in_menu",
  "sign_in_menu_inner": "SignInMenu-module-scss-module__I3YlJa__sign_in_menu_inner",
});
